import Datetimepicker from './Datetimepicker';
import UpdateEndTime from './UpdateEndTime';

const SELECTOR = '[data-timepicker]';

const OPTIONS = {
  format: 'LT',
  stepping: 15
};

class Timepicker {
  constructor() {
    $.each($(SELECTOR), (idx, elem) => {
      this.initialize($(elem));
    });

    this.attachEventHandlers();
  }

  attachEventHandlers() {
    $('body').on('cocoon:after-insert', (event, $addedTask) => {
      $.each($($addedTask).find(SELECTOR), (idx, elem) => {
        this.initialize($(elem));
        new UpdateEndTime();
      });
    });
  }

  initialize(input) {


    new Datetimepicker(input, OPTIONS);
  }
}

export default Timepicker;



// WEBPACK FOOTER //
// ./src/javascripts/Timepicker.js